import type { TFunction } from "i18next"

const NEEDS_INFO_CATEGORIES = {
  PROPERTY_DETAILS: "property_details",
  DESIGN_PREFERENCES: "design_preferences",
  PROJECT_REQUIREMENTS: "project_requirements",
  BUDGET: "budget",
  TIMELINE: "timeline",
  DOCUMENTS_PHOTOS: "documents_photos",
  OTHER: "other"
} as const

type NeedsInfoCategoryKeys = keyof typeof NEEDS_INFO_CATEGORIES
type NeedsInfoCategory = (typeof NEEDS_INFO_CATEGORIES)[NeedsInfoCategoryKeys]

const NEEDS_INFO_CATEGORY_ORDER: NeedsInfoCategory[] = [
  NEEDS_INFO_CATEGORIES.PROPERTY_DETAILS,
  NEEDS_INFO_CATEGORIES.DESIGN_PREFERENCES,
  NEEDS_INFO_CATEGORIES.PROJECT_REQUIREMENTS,
  NEEDS_INFO_CATEGORIES.BUDGET,
  NEEDS_INFO_CATEGORIES.TIMELINE,
  NEEDS_INFO_CATEGORIES.DOCUMENTS_PHOTOS,
  NEEDS_INFO_CATEGORIES.OTHER
]

const NEEDS_INFO_HINTED_CATEGORIES: NeedsInfoCategory[] = [
  NEEDS_INFO_CATEGORIES.PROPERTY_DETAILS,
  NEEDS_INFO_CATEGORIES.DESIGN_PREFERENCES,
  NEEDS_INFO_CATEGORIES.PROJECT_REQUIREMENTS
]

const NEEDS_INFO_I18N = "leadWorkspace.header.states.needsInfo"

const needsInfoCategoryLabel = (t: TFunction, category: NeedsInfoCategory | string) =>
  t(`${NEEDS_INFO_I18N}.categories.${category}`, { defaultValue: category })

const needsInfoCategoryHint = (t: TFunction, category: NeedsInfoCategory) =>
  NEEDS_INFO_HINTED_CATEGORIES.includes(category)
    ? t(`${NEEDS_INFO_I18N}.hints.${category}`)
    : null

export {
  NEEDS_INFO_CATEGORIES,
  NEEDS_INFO_CATEGORY_ORDER,
  needsInfoCategoryHint,
  needsInfoCategoryLabel,
  type NeedsInfoCategory
}
